import { Module } from '@nestjs/common';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { TypeOrmModule } from '@nestjs/typeorm';
import { EmployeeDetailsAdapter } from './dto/employee-details.adapter';
import { EmployeeDetailsController } from './employee-details.controller';
import { EmployeeDetails } from './employee-details.entity';
import { EmployeeDetailsService } from './employee-details.service';
import { EmployeeService } from '@gtpl/shared-services/attendance';
import { Departments } from '../departments/departments.entity';
import { EmployeeRepo } from './dto/employee.repository';
import { DepartmentService } from '@gtpl/shared-services/masters';
import { AttendanceService } from '@gtpl/shared-services/hrms';
import { EmployeeTrainingRepo } from './dto/employee-training-repo';
import { EmployeeTrainingAdapter } from './dto/employee-training-adapter';
import { EmployeeSkillMatrix } from './employee-skill-matrix.entity';
import { EmployeeSkillMatrixRepo } from './dto/employee-skill-matrix.repo';
import { EmployeeSkillMatrixAdapter } from './dto/employee-skill-matrix.adapter';


@Module({
  imports: [
    TypeOrmModule.forFeature([EmployeeDetails, Departments, EmployeeRepo, EmployeeSkillMatrix, EmployeeSkillMatrixRepo,EmployeeTrainingRepo]),
  ],
  controllers: [EmployeeDetailsController],
  providers: [EmployeeDetailsService, EmployeeDetailsAdapter, ApplicationExceptionHandler, EmployeeService, DepartmentService, AttendanceService, EmployeeSkillMatrixAdapter,EmployeeTrainingAdapter],
  exports: [EmployeeDetailsService]
})
export class EmployeeDetailsModule {



}
